import { render, staticRenderFns } from "./renda-basica-emergencial.vue?vue&type=template&id=bd779e72&scoped=true&"
import script from "./renda-basica-emergencial.vue?vue&type=script&lang=js&"
export * from "./renda-basica-emergencial.vue?vue&type=script&lang=js&"
import style0 from "./renda-basica-emergencial.vue?vue&type=style&index=0&id=bd779e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd779e72",
  null
  
)

export default component.exports